var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRazorpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    transform: "matrix(1.46224 0 0 1.45639 690.117 690.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-17",
    transform: "matrix(17.66 0 0 17.3 59.04 -0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.96,-10.17l-0.98,3.62l5.6,-3.64l-3.66,13.75l3.72,0l5.42,-20.31l-10.1,6.58z",
    fill: "rgb(51,149,255)",
    fillRule: "evenodd",
    id: "svg_3",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    transform: "translate(-112.42 -10.64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-19",
    transform: "matrix(17.66 0 0 17.3 -61.91 74.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.55,125.99l-1.54,5.75l7.63,0l3.12,-11.7l-9.21,5.95",
    fill: "rgb(7,38,84)",
    fillRule: "evenodd",
    id: "svg_4",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    transform: "translate(-6.19 -143.12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRazorpay);
export default __webpack_public_path__ + "static/media/ic_razorpay.b0d530c618aa4b31f654915e496814b9.svg";
export { ForwardRef as ReactComponent };